import { render, staticRenderFns } from "./ProductCardButtons.vue?vue&type=template&id=6d36b55c&"
import script from "./ProductCardButtons.vue?vue&type=script&lang=js&"
export * from "./ProductCardButtons.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports